module.exports = __webpack_public_path__ + "img/tg_02 (9).7e3cc28b.jpg";